import {ICellRendererParams} from "@ag-grid-community/core";
import {AgStop} from "../types";
import styled from "@emotion/styled";
import {DoneTaskIcon, GPSIcon, MagicIcon} from "../icons";
import {DoubleFieldCellValue} from "./DoubleFieldCellRenderer";
import {Text, Tooltip} from "@blueprintjs/core";
import {ETASource} from "../../manifest/details/enums/enums";
import {Maybe} from "graphql/jsutils/Maybe";
import {CSSProperties} from "react";

const getETAIconBySource = (etaSource: Maybe<string> | undefined) => {
  switch (etaSource) {
    case ETASource.COMPLETE_STOP:
      return DoneTaskIcon;
    case ETASource.GPS_UPDATE:
      return GPSIcon;
    case ETASource.OPTIMIZATION_SERVICE:
    case ETASource.ROUTE_PLANNING:
      return MagicIcon;
    default:
      return () => <></>;
  }
};

const getETATooltipBySource = (etaSource: Maybe<string> | undefined) => {
  let sourceText = "";
  switch (etaSource) {
    case ETASource.COMPLETE_STOP:
      sourceText = "Completed Stop";
      break;
    case ETASource.GPS_UPDATE:
      sourceText = "GPS Point";
      break;
    case ETASource.OPTIMIZATION_SERVICE:
      sourceText = "Optimization";
      break;
    case ETASource.ROUTE_PLANNING:
      sourceText = "Itinerary Planning";
      break;
    default:
      sourceText = "Unknown Source";
  }
  return `ETA calculated with ${sourceText}`;
};

export const ETACellRenderer = (
  params: ICellRendererParams<AgStop, DoubleFieldCellValue> & {style?: CSSProperties}
) => {
  if (!params.value) {
    return <></>;
  }
  const value = params.value;
  const Icon = getETAIconBySource(params.data?.etaSource);
  const style = params.style;

  return (
    <Tooltip placement="top" content={getETATooltipBySource(params.data?.etaSource)}>
      <Container data-testid="eta-container" style={style}>
        <ETATime>
          <div style={{height: "16px"}}>
            <Icon />
          </div>
          <Text ellipsize>{value.upperField.value}</Text>
        </ETATime>
        <ETADate ellipsize>{value.lowerField.value}</ETADate>
      </Container>
    </Tooltip>
  );
};

const Container = styled.div`
  font-family: "Roboto", sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
`;

const ETATime = styled.div`
  line-height: 16px;
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: 6px;
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  padding: 2px 4px;
  width: 100%;
  max-width: fit-content;
`;

const ETADate = styled(Text)`
  line-height: 16px;
  color: #6b7280;
`;
